import React from 'react'
import { color } from 'ui/src/styles/index'

interface IProps {
  isActive: boolean
  type: string
}

function DietFiltersIcons({ isActive, type }: IProps) {
  switch (type) {
    case 'dietfilter_milk':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12.0169 35.1647C12.0169 35.598 12.3669 35.9647 12.8169 35.9647H27.1836C27.6169 35.9647 27.9836 35.6147 27.9836 35.1647V17.6647L12.0169 33.6314V35.1647Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M12.8169 16.7988C12.3836 16.7988 12.0169 17.1488 12.0169 17.5988V22.3322L17.5503 16.7988H12.8169Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M13.0479 15.2167H19.1313L25.5146 8.83333H14.3313C13.9646 8.83333 13.6479 9.08333 13.5646 9.43333L12.2813 14.2167C12.1479 14.7167 12.5313 15.2167 13.0479 15.2167Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M25.4824 4.0319H14.5324C14.0906 4.0319 13.7324 4.39007 13.7324 4.8319V6.4319C13.7324 6.87373 14.0906 7.2319 14.5324 7.2319H25.4824C25.9242 7.2319 26.2824 6.87373 26.2824 6.4319V4.8319C26.2824 4.39007 25.9242 4.0319 25.4824 4.0319Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9654 4.03203C35.4987 3.56536 34.882 3.33203 34.2654 3.33203C33.6487 3.33203 33.032 3.56536 32.5654 4.03203L12.0154 24.582L4.03203 32.582C3.0987 33.5154 3.0987 35.032 4.03203 35.9654C4.4987 36.432 5.11536 36.6654 5.73203 36.6654C6.3487 36.6654 6.96536 36.432 7.43203 35.9654L35.982 7.41536C36.9154 6.48203 36.9154 4.96536 35.982 4.03203H35.9654Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )
    case 'dietfilter_treeNuts':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.8004 13.4643C20.1837 13.4643 20.5504 13.4643 20.9171 13.4643L26.8004 7.58099C24.8837 7.13099 22.4504 6.84766 19.8004 6.84766C13.6004 6.84766 8.56706 8.33099 8.56706 10.1643C8.56706 11.9977 13.6004 13.481 19.8004 13.481V13.4643Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M19.4147 14.9306C17.3647 14.9139 10.2314 14.6639 7.78135 11.9806C7.61469 11.7973 7.31469 11.8473 7.24802 12.0973C6.83135 13.9306 5.93135 19.6973 9.16469 25.1806L19.4147 14.9306Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M14.7003 30.949C16.1836 31.9656 17.9336 32.899 20.0003 33.699C34.3169 28.149 33.5669 16.599 32.8669 12.7656L14.6836 30.949H14.7003Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9664 4.03203C35.4997 3.56536 34.8831 3.33203 34.2664 3.33203C33.6497 3.33203 33.0331 3.56536 32.5664 4.03203L4.01641 32.582C3.08307 33.5154 3.08307 35.032 4.01641 35.9654C4.48307 36.432 5.09974 36.6654 5.71641 36.6654C6.33307 36.6654 6.94974 36.432 7.41641 35.9654L35.9664 7.41536C36.8997 6.48203 36.8997 4.96536 35.9664 4.03203Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )

    case 'dietfilter_peanut':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M28.6492 17.8826C28.6492 17.8826 28.6159 17.8826 28.5992 17.8659C28.3992 17.7992 28.2159 17.6992 28.0326 17.6159L17.6159 28.0326C17.6992 28.2159 17.7992 28.3992 17.8659 28.5992C17.8659 28.5992 17.8659 28.6326 17.8826 28.6492C18.2992 29.7326 18.9159 30.6992 19.7159 31.5326C22.4326 34.3326 26.6326 34.7826 29.8659 32.9492C30.0159 32.8826 30.1826 32.7826 30.3492 32.6826C30.5326 32.5659 30.6992 32.4326 30.8659 32.3159C31.1659 32.0992 31.4159 31.8826 31.6326 31.6659C31.8492 31.4326 32.0659 31.1826 32.2826 30.8826C32.3992 30.7159 32.5326 30.5659 32.6492 30.3659C32.7659 30.1992 32.8492 30.0326 32.9159 29.8826C34.7492 26.6326 34.2992 22.4492 31.4992 19.7326C30.6659 18.9326 29.6992 18.3159 28.6159 17.8992L28.6492 17.8826Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M11.817 22.3978C11.817 22.3978 11.8503 22.3978 11.867 22.4145C11.867 22.4145 11.9003 22.4145 11.917 22.4312L22.4503 11.8978C22.4503 11.8978 22.4503 11.8645 22.4336 11.8478C22.4336 11.8478 22.4336 11.8145 22.417 11.7978C21.9836 10.7312 21.3336 9.76449 20.5003 8.96449C18.667 7.18116 16.217 6.43116 13.8503 6.66449C11.4503 6.76449 8.36696 8.33116 8.36696 8.33116C8.36696 8.33116 6.8003 11.4145 6.7003 13.8145C6.46696 16.1812 7.21696 18.6312 9.0003 20.4645C9.8003 21.2978 10.767 21.9312 11.8336 22.3812L11.817 22.3978ZM8.48363 15.5478C7.7003 11.8812 9.38363 9.68116 9.4503 9.58116C9.71696 9.23116 10.217 9.18116 10.567 9.44782C10.917 9.71449 10.967 10.2145 10.7003 10.5645C10.6336 10.6478 9.41696 12.3145 10.0336 15.2145C10.1336 15.6478 9.8503 16.0645 9.41696 16.1645C9.36696 16.1645 9.3003 16.1812 9.2503 16.1812C8.88363 16.1812 8.5503 15.9312 8.46696 15.5478H8.48363Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9654 4.03203C35.4987 3.56536 34.882 3.33203 34.2654 3.33203C33.6487 3.33203 33.032 3.56536 32.5654 4.03203L4.03203 32.582C3.0987 33.5154 3.0987 35.032 4.03203 35.9654C4.4987 36.432 5.11536 36.6654 5.73203 36.6654C6.3487 36.6654 6.96536 36.432 7.43203 35.9654L35.982 7.41536C36.9154 6.48203 36.9154 4.96536 35.982 4.03203H35.9654Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )
    case 'dietfilter_soya':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.483 15.4832C16.0996 14.8665 15.833 13.5832 14.9163 12.6665C13.9996 11.7498 12.6996 11.4832 12.0996 12.0998C11.4996 12.7165 11.7496 13.9998 12.6663 14.9165C13.583 15.8332 14.883 16.0998 15.483 15.4832Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M24.8186 9.53092C19.0686 5.54759 12.3852 5.03092 8.70189 8.71426C5.01855 12.3976 5.53522 19.0809 9.51855 24.8309L24.8186 9.53092ZM10.9686 10.9643C12.2186 9.71426 14.4852 9.96426 16.0519 11.5309C17.6019 13.0809 17.8686 15.3643 16.6186 16.6143C15.3686 17.8643 13.1019 17.6143 11.5352 16.0476C9.98522 14.4976 9.71855 12.2143 10.9686 10.9643Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M15.1849 30.4647C20.9349 34.448 27.6182 34.9647 31.3016 31.2814C34.9849 27.598 34.4682 20.9147 30.4849 15.1647L15.1849 30.4647Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9693 4.03203C35.5026 3.56536 34.8859 3.33203 34.2693 3.33203C33.6526 3.33203 33.0359 3.56536 32.5693 4.03203L4.03594 32.582C3.1026 33.5154 3.1026 35.032 4.03594 35.9654C4.5026 36.432 5.11927 36.6654 5.73594 36.6654C6.3526 36.6654 6.96927 36.432 7.43594 35.9654L35.9693 7.41536C36.9026 6.48203 36.9026 4.96536 35.9693 4.03203Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )
    case 'dietfilter_egg':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.3155 8.04857C24.4822 5.66523 22.3322 4.0319 19.9988 4.0319C13.3988 4.0319 8.04883 17.0652 8.04883 23.7986C8.04883 24.5819 8.13216 25.3486 8.2655 26.0986L26.3155 8.04857Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M12.4336 33.215C14.5003 34.9316 17.1336 35.965 20.0003 35.965C26.6003 35.965 31.9503 30.515 31.9503 23.7983C31.9503 21.4983 31.3169 18.4483 30.2169 15.4316L12.4336 33.215Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9654 4.03203C35.4987 3.56536 34.882 3.33203 34.2654 3.33203C33.6487 3.33203 33.032 3.56536 32.5654 4.03203L4.03203 32.582C3.0987 33.5154 3.0987 35.032 4.03203 35.9654C4.4987 36.432 5.11536 36.6654 5.73203 36.6654C6.3487 36.6654 6.96536 36.432 7.43203 35.9654L35.9654 7.43203C36.8987 6.4987 36.8987 4.98203 35.9654 4.0487V4.03203Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )

    case 'dietfilter_fish':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M35.7835 19.8335C34.5501 17.7501 32.8501 16.0335 30.8501 14.8001L18.5501 27.1001C19.8001 27.3835 21.0835 27.5335 22.3835 27.5168C27.5335 27.5835 32.4335 25.2835 35.6835 21.2835C36.0001 20.8668 36.0335 20.3001 35.7668 19.8501L35.7835 19.8335ZM30.4168 19.7001C30.2168 19.9001 29.9335 20.0168 29.6501 20.0168C29.2168 20.0168 28.8168 19.7501 28.6501 19.3501C28.4835 18.9501 28.5835 18.4835 28.8835 18.1835C29.1835 17.8835 29.6501 17.7835 30.0668 17.9501C30.4668 18.1168 30.7335 18.5168 30.7335 18.9501C30.7335 19.2335 30.6168 19.5168 30.4168 19.7168V19.7001Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M6.23156 25.9809L9.34822 24.9809L21.7816 12.5475C17.9316 12.8309 14.2982 14.5809 11.6816 17.5142L7.66489 14.0975C7.08156 13.5975 6.24822 13.5642 5.61489 13.9975C4.98156 14.4309 4.71489 15.2309 4.96489 15.9475L5.46489 17.4309C5.93156 18.7642 5.83156 20.2309 5.21489 21.5142L4.18156 23.6475C3.88156 24.2475 3.98156 24.9809 4.41489 25.4809C4.84822 25.9975 5.56489 26.1975 6.19822 25.9809H6.23156Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9654 4.03203C35.4987 3.56536 34.882 3.33203 34.2654 3.33203C33.6487 3.33203 33.032 3.56536 32.5654 4.03203L12.2987 24.2987L4.03203 32.582C3.0987 33.5154 3.0987 35.032 4.03203 35.9654C4.4987 36.432 5.11536 36.6654 5.73203 36.6654C6.3487 36.6654 6.96536 36.432 7.43203 35.9654L35.982 7.41536C36.9154 6.48203 36.9154 4.96536 35.982 4.03203H35.9654Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )

    case 'dietfilter_crustacean':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5124 15.5658L16.6124 17.8324L17.8957 16.4991L17.0457 14.7491C17.1624 14.5158 17.2457 14.2658 17.2457 13.9824C17.2457 13.0991 16.5624 12.3991 15.7124 12.3991C14.8624 12.3991 14.179 13.1158 14.179 13.9824C14.179 14.7824 14.7624 15.4491 15.5124 15.5491V15.5658Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M6.43222 17.2676C6.53222 17.3176 6.68222 17.3676 6.89889 17.4176C7.04889 18.4676 7.26555 19.7676 7.49888 20.951C7.81555 22.5676 9.28222 23.4843 10.6489 24.0176L12.0322 22.601C10.7989 22.2343 9.39888 21.5676 9.21555 20.601C9.01555 19.601 8.83222 18.501 8.69888 17.551C10.0322 17.4343 11.5989 16.8176 12.4489 14.801C13.5156 12.3176 12.4322 10.5843 11.6489 9.75098C11.3489 9.41765 10.8322 9.46765 10.5656 9.83431L7.93222 13.7176L8.04888 7.43431C8.04888 6.83431 7.38222 6.51765 6.96555 6.93431C4.71555 9.11765 0.365551 14.351 6.44888 17.251L6.43222 17.2676Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.398 9.71719L28.798 16.5339C29.5814 17.2005 30.498 17.4672 31.3147 17.5505C31.1647 18.5005 30.998 19.6005 30.798 20.6005C30.5647 21.8172 28.5647 22.5005 27.3147 22.7672C27.0147 21.7172 26.348 20.7839 25.4314 20.0172L16.1647 29.6005L16.8647 29.7672C19.2814 30.6005 21.3147 30.0172 22.4814 29.6839C22.898 29.5672 23.3147 29.5339 23.7314 29.5839L26.5814 29.9339C26.948 29.9839 27.2647 30.2005 27.4314 30.5505L29.148 34.0505C30.448 30.8005 28.2147 28.7339 28.2147 28.7339C27.9314 28.1505 26.898 27.8172 26.0314 27.6172C26.1814 27.4672 26.3147 27.3005 26.448 27.1339L28.748 27.4172C28.9814 27.4505 29.198 27.6005 29.298 27.8172L30.9647 31.2505C32.4314 28.1339 30.0814 26.2839 30.0814 26.2839C29.748 25.5839 28.2647 25.2672 27.398 25.1172C27.448 24.9339 27.4647 24.7339 27.498 24.5339C28.898 24.2672 32.0314 23.3839 32.5147 20.9172C32.748 19.7339 32.9647 18.4172 33.1147 17.3839C33.3314 17.3339 33.498 17.2839 33.5814 17.2339C37.7647 15.2339 37.0147 12.1339 35.4147 9.70052L35.398 9.71719Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M27.8147 15.2996L30.948 12.0663L32.0147 10.9496L35.4147 7.43294C36.3147 6.49961 36.3147 4.98294 35.4147 4.04961C34.9647 3.58294 34.3647 3.34961 33.7814 3.34961C33.198 3.34961 32.598 3.58294 32.148 4.04961L24.0147 12.4663L22.698 13.8163L18.6314 18.0329L12.3314 24.5496L11.5314 25.3829L9.23138 27.7663L4.54805 32.5996C3.64805 33.5329 3.64805 35.0496 4.54805 35.9829C4.99805 36.4496 5.59805 36.6829 6.18138 36.6829C6.76471 36.6829 7.36471 36.4496 7.81471 35.9829L10.6814 33.0163L11.898 31.7663L13.6647 29.9329L24.0647 19.1663L27.7814 15.3329L27.8147 15.2996Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M10.7832 34.0669V34.0169V34.0503C10.7832 34.0503 10.7832 34.0503 10.7832 34.0669Z"
            fill="white"
          />
          <path
            d="M16.9794 18.6003L16.9128 18.6669C16.9128 18.6669 16.9628 18.6503 16.9961 18.6336V18.6003H16.9794Z"
            fill="white"
          />
        </svg>
      )

    case 'dietfilter_mollusc':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.3672 32.1161L14.0005 31.6328L12.8672 32.7661C13.6505 33.3328 14.6339 33.6995 15.7505 33.6995C15.7839 33.6995 15.8005 33.6995 15.8339 33.6995C15.3505 33.2661 14.8505 32.7495 14.3672 32.1328V32.1161Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M26.4055 31.0497L26.2721 31.2497L26.1888 31.3664L25.6055 32.1664C25.1388 32.7664 24.6555 33.2664 24.1888 33.6831C24.2055 33.6831 24.2388 33.6831 24.2555 33.6831C26.7055 33.6831 28.6888 31.9831 28.6888 29.8831C28.6888 29.5831 28.6388 29.2664 28.5555 28.9831C27.6555 29.6997 26.8555 30.3997 26.4221 31.0497H26.4055Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M15.1495 30.482L15.6495 31.1654C17.3161 33.2987 18.6495 33.682 19.9828 33.682C21.3161 33.682 22.6495 33.2987 24.3161 31.1654L24.8661 30.4154C24.9328 30.332 24.9828 30.2487 25.0495 30.1654C27.0828 27.132 33.6661 24.5654 33.6661 20.3154C33.5495 17.932 32.8995 15.6987 31.8661 13.7487L15.1328 30.482H15.1495Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M9.21771 25.1496L26.3344 8.01628C24.651 7.06628 22.7844 6.48294 20.801 6.34961V9.99961C20.801 10.4329 20.451 10.7996 20.001 10.7996C19.551 10.7996 19.201 10.4496 19.201 9.99961V6.34961C16.101 6.54961 13.2677 7.84961 11.051 9.91628L13.7177 12.5829C14.0344 12.8996 14.0344 13.3996 13.7177 13.7163C13.5677 13.8663 13.351 13.9496 13.151 13.9496C12.951 13.9496 12.7344 13.8663 12.5844 13.7163L9.95104 11.0829C7.85104 13.5329 6.50104 16.7496 6.31771 20.3329C6.31771 22.2163 7.60104 23.7663 9.21771 25.1663V25.1496Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9693 4.03203C35.5026 3.56536 34.8859 3.33203 34.2693 3.33203C33.6526 3.33203 33.0359 3.56536 32.5693 4.03203L4.03594 32.582C3.1026 33.5154 3.1026 35.032 4.03594 35.9654C4.5026 36.432 5.11927 36.6654 5.73594 36.6654C6.3526 36.6654 6.96927 36.432 7.43594 35.9654L35.9859 7.41536C36.9193 6.48203 36.9193 4.96536 35.9859 4.03203H35.9693Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )

    case 'dietfilter_sulphite':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M22.8554 11.4986V6.46523L23.5887 4.51523C23.622 4.39857 23.622 4.2819 23.5554 4.1819C23.4887 4.0819 23.372 4.0319 23.2554 4.0319H16.7387C16.622 4.0319 16.5054 4.0819 16.4387 4.1819C16.372 4.2819 16.3554 4.39857 16.4054 4.51523L17.1387 6.46523V17.2152L22.8554 11.4986Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M26.7875 22.9159L25.9708 21.7326L25.1375 20.5326L10.3542 35.3159C11.0375 35.7492 11.8542 35.9826 12.6875 35.9826H27.3208C28.9708 35.9826 30.4875 35.0659 31.2542 33.5992C32.0208 32.1326 31.9208 30.3659 30.9708 28.9992L26.7708 22.9326L26.7875 22.9159Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9693 4.03203C35.5026 3.56536 34.8859 3.33203 34.2693 3.33203C33.6526 3.33203 33.0359 3.56536 32.5693 4.03203L12.1359 24.4654L4.03594 32.582C3.1026 33.5154 3.1026 35.032 4.03594 35.9654C4.5026 36.432 5.11927 36.6654 5.73594 36.6654C6.3526 36.6654 6.96927 36.432 7.43594 35.9654L35.9859 7.41536C36.9193 6.48203 36.9193 4.96536 35.9859 4.03203H35.9693Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )

    case 'dietfilter_sesame':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M32.0654 15.4477C31.5154 15.3144 30.932 15.4811 30.5154 15.8644C30.0987 16.2477 29.6487 16.5977 29.1487 16.8977C28.932 17.0311 28.6987 17.1311 28.4487 17.1811L23.4987 22.1311C23.2654 23.2977 23.3654 24.5311 23.832 25.6311C24.1487 26.3811 24.732 26.9644 25.482 27.2811C26.232 27.5977 27.0654 27.5977 27.8154 27.2811C29.0154 26.7977 30.0487 25.9811 30.782 24.9311C31.532 23.8811 31.9487 22.6311 32.0154 21.3477C32.082 20.1811 32.4654 19.0477 33.1154 18.0811C33.432 17.6144 33.4987 17.0144 33.282 16.4811C33.0654 15.9477 32.6154 15.5644 32.0654 15.4311V15.4477Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M9.63103 21.6502C10.3644 22.0502 11.1477 22.2835 11.9644 22.4002L16.6977 17.6668C16.3477 16.9835 15.9144 16.3335 15.3644 15.8168C14.431 14.8835 13.231 14.2835 11.931 14.1002C10.631 13.9168 9.31437 14.1668 8.16437 14.8168C7.46437 15.2168 6.93103 15.8668 6.71437 16.6502C6.4977 17.4335 6.58103 18.2668 6.96437 18.9668C7.58103 20.1002 8.51437 21.0335 9.63103 21.6502Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M25.8993 31.7818C25.4493 31.4318 25.0327 31.0318 24.666 30.5984C24.4993 30.3984 24.366 30.1818 24.266 29.9484C23.866 28.9818 23.2327 28.1151 22.4327 27.4151C21.6493 26.6984 20.6827 26.2151 19.666 25.9818L14.416 31.2318C15.066 32.1818 15.9493 32.9651 16.9827 33.4818C18.1327 34.0484 19.4327 34.2818 20.716 34.1318C21.8827 34.0151 23.0493 34.1984 24.116 34.6984C24.6327 34.9318 25.2327 34.9151 25.7327 34.6151C26.216 34.3151 26.5327 33.8151 26.566 33.2318C26.5993 32.6651 26.3493 32.1151 25.8993 31.7651V31.7818Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M18.9832 14.3825C19.1832 14.5158 19.3665 14.6658 19.5332 14.8325L24.5665 9.79914C24.3332 8.73248 23.8165 7.74914 23.0665 6.96581C22.1665 6.01581 20.9665 5.38248 19.6665 5.18248C18.8665 5.04914 18.0498 5.24914 17.3998 5.71581C16.7498 6.18248 16.2998 6.89914 16.1498 7.69914C15.9332 8.96581 16.0832 10.2825 16.5832 11.4658C17.0832 12.6491 17.9165 13.6658 18.9665 14.3991L18.9832 14.3825Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9654 4.03203C35.4987 3.56536 34.882 3.33203 34.2654 3.33203C33.6487 3.33203 33.032 3.56536 32.5654 4.03203L4.03203 32.582C3.0987 33.5154 3.0987 35.032 4.03203 35.9654C4.4987 36.432 5.11536 36.6654 5.73203 36.6654C6.3487 36.6654 6.96536 36.432 7.43203 35.9654L35.9654 7.41536C36.8987 6.48203 36.8987 4.96536 35.9654 4.03203Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )

    case 'dietfilter_celery':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.5164 9.04872C11.6831 9.01538 11.8664 8.99872 12.0331 8.99872C12.2497 8.99872 12.4664 9.03205 12.7164 9.08205C13.2331 9.21538 13.6331 9.41538 13.9664 9.64872C14.2831 9.28205 14.7331 8.93205 15.3164 8.74872C15.5831 8.66538 15.8497 8.61538 16.1164 8.61538C17.2997 8.61538 18.0997 9.39872 18.2497 9.54872C18.5497 9.86538 18.7664 10.2154 18.9331 10.5654C19.1164 10.4487 19.2997 10.3487 19.5164 10.2654C19.8331 10.1487 20.1497 10.0987 20.4831 10.0987C21.8664 10.0987 22.8997 11.0987 22.9497 11.1487C22.9831 11.1821 23.0164 11.2487 23.0497 11.2821L24.8497 9.48205C24.7997 9.31538 24.7164 9.14872 24.6331 8.98205C24.4997 8.76538 23.6831 7.56538 22.4164 7.68205C21.3664 7.76538 20.7664 8.71538 20.6664 8.84872C20.7164 8.74872 21.1664 7.36538 20.5164 6.16538C20.3331 5.83205 19.7164 5.03205 18.7164 5.06538C17.6164 5.11538 16.9664 6.01538 16.9164 6.08205C16.8497 5.86538 16.5331 5.06538 15.6497 4.56538H15.6164C14.2831 3.83205 12.5664 4.79872 12.4997 6.31538V6.34872C12.4664 7.34872 12.9664 8.04872 13.1331 8.21538C13.1331 8.21538 12.1164 8.29872 11.4831 9.03205L11.5164 9.04872Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M24.7163 20.9329L20.9329 24.7163C24.5496 28.8329 26.6996 31.2163 28.1829 32.4996C30.6496 34.5996 32.4996 34.2996 33.3829 33.4163C34.2829 32.5163 34.5663 30.6829 32.4829 28.2163C31.1996 26.7163 28.8163 24.5663 24.6996 20.9496L24.7163 20.9329Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M26.8503 18.7975L25.3503 20.2975C29.4503 23.8975 31.8669 26.0809 33.1669 27.6142C33.9503 28.5475 34.4503 29.4142 34.7169 30.1975C34.7836 30.1475 34.8169 30.0975 34.8836 30.0309C35.8503 28.9309 36.3669 27.0975 33.7169 24.4142C32.4003 23.0975 30.1003 21.2642 26.8503 18.7975Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M9.96547 12.5154C10.1988 13.482 10.8821 14.0154 11.0655 14.1487C10.9988 14.1654 9.94881 14.5487 9.59881 15.5987C9.29881 16.5487 9.89881 17.3654 10.1821 17.6154C11.1155 18.482 12.4155 18.4987 12.6821 18.482C12.4655 18.5487 11.4655 18.8987 11.1155 19.8487C10.6821 21.0154 11.6155 22.1487 11.7821 22.3154C11.8321 22.3654 11.8821 22.3654 11.9155 22.4154L22.4155 11.9154C22.4155 11.9154 22.3655 11.8154 22.3155 11.782C22.1321 11.5987 21.0155 10.6654 19.8321 11.1154C18.8488 11.482 18.5155 12.5654 18.4655 12.7154C18.4655 12.5987 18.5321 11.1654 17.5988 10.1654C17.3321 9.89871 16.5155 9.28205 15.5821 9.59871C14.5321 9.93205 14.1488 10.982 14.1155 11.0487C13.9821 10.8654 13.4655 10.182 12.4988 9.94871C12.4821 9.94871 12.4655 9.94871 12.4655 9.94871C10.9821 9.61538 9.58214 10.9987 9.93214 12.482C9.93214 12.482 9.93214 12.4987 9.93214 12.5154H9.96547Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M20.2975 25.3503L18.7975 26.8503C21.2642 30.1003 23.0975 32.4003 24.4309 33.7169C27.1142 36.3836 28.9475 35.8503 30.0475 34.8836C30.1142 34.8336 30.1642 34.7836 30.2142 34.7169C29.3642 34.4336 28.4975 33.9169 27.6142 33.1669C26.0809 31.8669 23.8975 29.4503 20.3142 25.3503H20.2975Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M4.58346 15.6819C5.08346 16.5652 5.8668 16.8819 6.08346 16.9486C6.0168 16.9819 5.1168 17.6319 5.0668 18.7486C5.03346 19.7486 5.83346 20.3652 6.1668 20.5486C7.3668 21.1819 8.73346 20.7319 8.83346 20.6986C8.68346 20.7819 7.75013 21.3986 7.6668 22.4486C7.5668 23.6986 8.7668 24.5319 8.98346 24.6486C9.15013 24.7319 9.3168 24.8152 9.48346 24.8652L11.2835 23.0652C11.2835 23.0652 11.1835 23.0152 11.1501 22.9652C10.6001 22.4319 9.73346 21.0152 10.2668 19.5319C10.3335 19.3319 10.4501 19.1319 10.5668 18.9486C10.2168 18.7819 9.88346 18.5652 9.5668 18.2819C9.05013 17.8152 8.30013 16.6652 8.73346 15.3319C8.93346 14.7486 9.28346 14.2986 9.63346 13.9819C9.40013 13.6486 9.18346 13.2152 9.05013 12.6986C8.9668 12.3152 8.9668 11.9152 9.0168 11.5319C8.28346 12.1652 8.2168 13.1152 8.20013 13.1819C8.03346 13.0319 7.33346 12.5152 6.33346 12.5486H6.30013C4.78346 12.6152 3.8168 14.3319 4.53346 15.6819C4.53346 15.6819 4.53346 15.6986 4.55013 15.7152L4.58346 15.6819Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9654 4.03203C35.4987 3.56536 34.882 3.33203 34.2654 3.33203C33.6487 3.33203 33.032 3.56536 32.5654 4.03203L11.932 24.6654L4.03203 32.582C3.0987 33.5154 3.0987 35.032 4.03203 35.9654C4.4987 36.432 5.11536 36.6654 5.73203 36.6654C6.3487 36.6654 6.96536 36.432 7.43203 35.9654L35.9654 7.43203C36.8987 6.4987 36.8987 4.98203 35.9654 4.0487V4.03203Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )

    case 'dietfilter_mustard':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_484_2845)">
            <path
              d="M14.9832 12.2168C13.7665 12.2168 12.7832 12.9835 12.7832 13.9168V21.5668L22.1499 12.2168H14.9832Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M12.7832 35.1669C12.7832 35.6503 13.2999 36.0503 13.9332 36.0503H26.0665C26.6999 36.0503 27.2165 35.6503 27.2165 35.1669V18.4336L12.7999 32.8503V35.1669H12.7832Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M24.5659 9.80065V9.21732C24.5659 8.68398 23.9492 8.25065 23.1992 8.25065H21.7826L20.6492 3.33398H19.3659L18.2326 8.25065H16.8159C16.0659 8.25065 15.4492 8.68398 15.4492 9.21732V10.6173H23.7659L24.5826 9.80065H24.5659Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
            <path
              d="M35.9673 4.04961C35.5007 3.58294 34.884 3.34961 34.2673 3.34961C33.6506 3.34961 33.034 3.58294 32.5673 4.04961L24.4007 12.2163L12.784 23.8329L4.03398 32.5829C3.10065 33.5163 3.10065 35.0329 4.03398 35.9663C4.50065 36.4329 5.11732 36.6663 5.73398 36.6663C6.35065 36.6663 6.96732 36.4329 7.43398 35.9663L12.8007 30.5996L27.2173 16.1829L35.9673 7.43294C36.9007 6.49961 36.9007 4.98294 35.9673 4.04961Z"
              fill={isActive ? color.iconsSelected : color.costaRedFont}
            />
          </g>
          <defs>
            <clipPath id="clip0_484_2845">
              <rect
                width="33.3333"
                height="33.3333"
                fill="white"
                transform="translate(3.33398 3.33398)"
              />
            </clipPath>
          </defs>
        </svg>
      )

    case 'dietfilter_lupin':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.419 13.9336C20.2857 13.9336 20.1357 13.9503 20.0023 13.9503C17.5023 13.9503 15.5523 12.8003 14.969 11.1836C10.6523 12.8503 7.65234 16.4836 7.65234 20.7003C7.65234 22.3836 8.13568 23.9669 8.98568 25.3669L20.4357 13.9169L20.419 13.9336Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M15.2891 30.3482C16.8224 30.8982 18.5057 31.1982 20.2724 31.1982C27.2391 31.1982 32.8891 26.4982 32.8891 20.6982C32.8891 18.5482 32.1057 16.5482 30.7557 14.8815L15.2891 30.3482Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M20.0023 12.3651C21.119 12.3651 22.1023 12.0651 22.769 11.5984L23.3357 11.0318C23.4357 10.8818 23.519 10.7318 23.569 10.5818C23.6023 10.4651 23.6357 10.3318 23.6357 10.2151C23.6357 9.03177 22.019 8.0651 20.019 8.0651C18.019 8.0651 16.4023 9.03177 16.4023 10.2151C16.4023 10.3818 16.4357 10.5484 16.5023 10.6984C16.869 11.6484 18.3023 12.3651 20.019 12.3651H20.0023Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9693 4.03203C35.5026 3.56536 34.8859 3.33203 34.2693 3.33203C33.6526 3.33203 33.0359 3.56536 32.5693 4.03203L4.03594 32.582C3.1026 33.5154 3.1026 35.032 4.03594 35.9654C4.5026 36.432 5.11927 36.6654 5.73594 36.6654C6.3526 36.6654 6.96927 36.432 7.43594 35.9654L35.9693 7.41536C36.9026 6.48203 36.9026 4.96536 35.9693 4.03203Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )

    case 'dietfilter_cereals':
      return (
        <svg
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.4193 14.8158L15.486 16.8825C15.0027 16.7658 14.5027 16.6825 13.986 16.6992C11.286 16.7992 9.01933 19.0325 7.96933 20.2658C7.586 20.7158 7.55267 21.3991 7.90267 21.8158C8.41933 22.4325 9.286 23.3158 10.386 23.9825L23.986 10.3825C23.3193 9.28248 22.436 8.41582 21.8193 7.89915C21.386 7.54915 20.7193 7.56582 20.2693 7.96582C19.036 9.01582 16.8193 11.2825 16.7027 13.9825C16.686 14.5158 16.7693 15.0158 16.886 15.4825L14.8193 13.4158C14.9193 11.8491 14.786 9.18248 13.0693 7.46582C11.236 5.63248 8.286 5.59915 6.80266 5.73248C6.25266 5.78248 5.786 6.23248 5.75267 6.78248C5.61933 8.28248 5.65267 11.2158 7.486 13.0491C9.20267 14.7658 11.8693 14.8991 13.436 14.7991L13.4193 14.8158Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M30.4336 29.0319C30.4336 29.0319 30.5669 28.9652 30.6169 28.9319C31.8502 27.8819 34.0669 25.6152 34.1669 22.9152C34.2669 20.2152 32.2169 18.1152 31.0502 17.1485C30.6169 16.7985 29.9502 16.8152 29.5002 17.2152C28.2669 18.2652 26.0502 20.5319 25.9336 23.2319C25.9169 23.7652 26.0002 24.2652 26.1169 24.7319L23.5002 22.1152L22.1002 23.5152L24.7169 26.1319C24.2336 26.0152 23.7336 25.9319 23.2169 25.9485C20.5169 26.0485 18.2502 28.2819 17.2002 29.5152C16.8169 29.9652 16.7836 30.6485 17.1336 31.0652C18.1002 32.2152 20.2002 34.2819 22.9002 34.1819C25.6002 34.0819 27.8669 31.8485 28.9169 30.6319C28.9669 30.5819 28.9836 30.5152 29.0169 30.4485L32.6002 34.0319C32.9836 34.4152 33.6169 34.4152 34.0002 34.0319C34.3836 33.6485 34.3836 33.0152 34.0002 32.6319L30.4169 29.0485L30.4336 29.0319Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
          <path
            d="M35.9693 4.03203C35.5026 3.56536 34.8859 3.33203 34.2693 3.33203C33.6526 3.33203 33.0359 3.56536 32.5693 4.03203L11.9193 24.682L4.03594 32.582C3.1026 33.5154 3.1026 35.032 4.03594 35.9654C4.5026 36.432 5.11927 36.6654 5.73594 36.6654C6.3526 36.6654 6.96927 36.432 7.43594 35.9654L35.9693 7.41536C36.9026 6.48203 36.9026 4.96536 35.9693 4.03203Z"
            fill={isActive ? color.iconsSelected : color.costaRedFont}
          />
        </svg>
      )
    default:
      return ''
  }
}

export default DietFiltersIcons
